import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LovComponent } from './lov.component';

const routes: Routes = [{ path: '', component: LovComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LovRoutingModule { }


